// Need to use the React-specific entry point to allow generating React hooks
import { createApi } from '@reduxjs/toolkit/query/react'

import { baseQuery, getDefaultParams } from './queries'
import { CompanyProfile } from '../../types/api-types'
import { store } from '../store/store'
import { RawConfig } from '../store/slice/configSlice'
import { getDevice } from '../../utils/device'

// API used for the Config ressource
export const apiConfig = createApi({
    baseQuery: baseQuery,
    endpoints: (builder) => ({
        getConfig: builder.query<CompanyProfile, void>({
            query: () => {
                const storeConfig = store.getState().config.config
                let fullUrl = '/config'
                if (storeConfig && storeConfig['api_prefix']) {
                    fullUrl =
                        (!storeConfig['api_prefix'].match(/^\//) ? '/' : '') +
                        storeConfig['api_prefix'] +
                        '/config'
                }

                // ---- Default Param for request ----
                const defaultConfig = getDefaultParams()

                // ---- Init payload ----
                const configParams: RawConfig = defaultConfig ? defaultConfig : {}

                // ---- Ajout pour les incrementations de compteurs en back ----
                configParams.module = 'switch_model'
                for (const field of ['cta_location', 'cta_version']) {
                    if (storeConfig && storeConfig[field]) {
                        configParams[field] = storeConfig[field]
                    }
                }
                const queryConfig = store.getState().config.queryParams
                for (const field of ['domain', 'extra_param', 'origin']) {
                    if (queryConfig && queryConfig[field]) {
                        configParams[field] = queryConfig[field]
                    }
                }

                // ---- Ajout du device ----
                configParams['device'] = getDevice()

                return {
                    url: fullUrl,
                    params: configParams,
                }
            },
        }),
    }),
    reducerPath: 'apiConfig',
})

// Export hooks for usage in function components, which are
// auto-generated based on the defined endpoints
export const { useGetConfigQuery } = apiConfig
